export const userRoutes = [
  {
    path: '/users',
    name: 'users',
    component: () => import('./views/ListUsers.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin', 'admin users & supervisors'],
    },
  },
  {
    path: '/users/add',
    name: 'users/add',
    component: () => import('./views/CreateUser.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin', 'admin users & supervisors'],
    },
  },
  {
    path: '/users/:username',
    name: 'users/detail',
    component: () => import('./views/UserDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin', 'admin users & supervisors'],
    },
  },
]
